// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-typography-title{margin-bottom:16px;color:var(--z2kad5);font-size:20px;font-weight:var(--1eohhj8);line-height:24px}@media only screen and (min-width:992px){.product-typography-title{margin-bottom:32px;font-size:22px;line-height:26px}}.product-typography__wrapper{display:none}.product-typography__wrapper.visible{display:block}@media only screen and (min-width:992px){.product-typography__wrapper{display:block}}", ""]);
// Exports
module.exports = exports;
